document.addEventListener('turbolinks:load', function() {
  gtag('config', 'G-BP556TYDVK')
});